<template>
    <div class="antv-chart-mini">
        <div class="chart-wrapper" :style="{ height: 46 }">
            <v-chart :force-fit="true" :height="height" :data="data" :padding="[36, 0, 18, 0]">
                <v-tooltip/>
                <v-smooth-area position="x*y"/>
            </v-chart>
        </div>
    </div>
</template>
<script>
    const tooltip = [
        'x*y',
        (x, y) => ({
            name: x,
            value: y
        })
    ]
    export default {
        name: 'MiniAreaParking',
        props: {
            chartData: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                data: [],
                tooltip,
                height: 100
            }
        },
        watch: {
            chartData: {
                deep: true,
                handler(val) {
                    this.data = []
                    for (let i = 0; i < val.dateTimeData.length; i++) {
                       //显示框有点小，只显示14天内即可
                        if (i > 14) {
                            break
                        }
                        this.data.push({
                            x: val.dateTimeData[i],
                            y: val.realParkingData[i] + val.freeParkingData[i] + val.abnormalParkingData[i]
                        })
                    }
                }
            }
        },


    }
</script>

<style lang="scss" scoped>
    .antv-chart-mini {
        position: relative;
        width: 100%;

        .chart-wrapper {
            position: absolute;
            bottom: -28px;
            width: 100%;
            /*    margin: 0 -5px;
                overflow: hidden;*/
        }
    }
</style>
